<template>
  <div class="form_section">
    <h2 v-if="heading" class="form_section--heading">{{ heading }}</h2>

    <div :class="['form_section--main', {'columns is-multiline my-0': !hideColumns}]">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "RegisterSection",
  props: {
    heading: String,
    hideColumns: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.form_section {
  margin: 0 auto 30px;
  padding-bottom: 30px;

  &--heading {
    margin-bottom: 0.75rem;
    padding: 0 4px 8px;
    border-bottom: 1px solid $border;
    color: $text-light;
    font-weight: bold;
    text-transform: uppercase;
  }

  &--main {
    padding: 0 1rem;
  }
}

</style>
